import React, { useState, useEffect} from 'react';
import {Helmet} from "react-helmet";
import {Button} from "../../components/buttons"
import axios from "axios";
import {API} from "../../config";
import numeral from 'numeral';
import { Nav } from 'react-bootstrap';
import LandingPageNav from '../../components/navbars/landingPage';
import FooterLandingPage from '../../components/footers/landing';
import Section from "../../components/landingPage/sections";
import { trackEvent } from '../../services/analytics';

const ShippingRates = (props) => {
    const [ areaLoadingSingle, setAreaLoadingSingle ] = useState(false);
    const [ areaLoadingDouble, setAreaLoadingDouble ] = useState(false);
    const [ inputType , setInputType ] = useState('origin')
    const [ originAreaInput, setOriginAreaInput ] = useState('');
    const [ destinationAreaInput, setDestinationAreaInput ] = useState('');
    const [ oAreas, setOAreas ] = useState([]);
    const [ dAreas, setDAreas ] = useState([]);
    const [ originId, setOriginId ] = useState('');
    const [ destinationId, setDestinationId ] = useState('');
    const [ open, setOpen ] = useState(false);
    const [ couriers, setCouriers ] = useState({
        courierOption: [],
        courierOptionFiltered:[],
        courierSameDay:0,
        courierParcel:0,
        courierInstant:0,
        courierOvernight:0,
        courierStandard:0,
        courierFreight: 0,
        shippingType: 0,
        serviceType: 0,
    });
    const [ submitLoading, setSubmitLoading ] = useState(false)
    const [ item, setItem ] = useState({
        weight:'1000',
        height:'1',
        length:'1',
        width:'1'
    })
    const [ oSelectedArea, setOSelectedArea ] = useState({
        filled:false
    });
    const [ dSelectedArea, setDSelectedArea ] = useState({
        filled:false
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (inputType === 'origin') {
                searchPlace ( originAreaInput,inputType ).then (  r => setOAreas(r.data.areas))
            } else {
                searchPlace ( destinationAreaInput,inputType ).then (  r => setDAreas(r.data.areas))
            }
            
            // Send Axios request here
        }, 500);

        return () => clearTimeout(delayDebounceFn)
    }, [originAreaInput, destinationAreaInput])

    const onChange = type => async e => {
        setInputType(type);
        setAreaLoadingSingle(true);

        if (type === 'origin') {
            setOriginId('')
            setOriginAreaInput(e.target.value);
            setOSelectedArea({filled:false})
        } else {
            setDestinationId('')
            setDestinationAreaInput(e.target.value);
            setDSelectedArea({filled:false})
        }
    };

    const onItemChange = name => e => {
        setItem({
            ...item,
            [name]: e.target.value
        })
    }

    const searchPlace = async (value) => {
        try {
            const res = await axios.get(`${API}/v1/maps/areas?countries=ID&input=${value}&type=single`, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            });
            setAreaLoadingSingle(false);
            return res
        } catch (e) {
            console.log (e)
        }
        setAreaLoadingSingle(false)
    };

    const onSelectDistrict = async (i,type) => {
        console.log(i)
        setAreaLoadingDouble(true);
        if (type === 'origin'){
            setOriginAreaInput(i.administrative_division_level_1_name+ ', ' + i.administrative_division_level_2_name+ ', ' + i.administrative_division_level_3_name,);
            setOAreas([])
            setOriginId(i.id)
        } else {
            setDestinationAreaInput(i.administrative_division_level_1_name+ ', ' + i.administrative_division_level_2_name+ ', ' + i.administrative_division_level_3_name,);
            setDAreas([])
            setDestinationId(i.id)
        }
        
        
        setAreaLoadingDouble(false)
    }


    const serviceTypeChange = e => {
        setCouriers({...couriers,
        serviceType:e,
        courierOptionFiltered: couriers.courierOption.filter(i =>
            i.service_type === e && i.shipping_type !== 'freight'
        )
        })
    };
    
    const courierParcelNav = () => {
        const pa = couriers.courierInstant;
        const sa = couriers.courierSameDay;
        const on = couriers.courierOvernight;
        const st = couriers.courierStandard;
    
        if (pa > 0 && sa === 0 && on === 0 && st === 0) {
        return false
        } else if (pa === 0 && sa > 0 && on === 0 && st === 0) {
        return false
        } else if (pa === 0 && sa === 0 && on > 0 && st === 0) {
        return false
        } else if (pa === 0 && sa === 0 && on === 0 && st > 0) {
        return false
        } else {
        return true
        }
    };

    const shippingTypeChange = e => {
        let newValues;
        if( e === 'freight') {
        newValues = {...couriers,
            serviceType: 'standard',
            shippingType:e,
            courierOptionFiltered: couriers.courierOption.filter(i => i.shipping_type === e)}
        } else {
        newValues = {...couriers,
            shippingType:e,
            courierOptionFiltered: couriers.courierOption.filter(i =>
                i.shipping_type === e && i.service_type === 'standard')
        }
        }
        setCouriers(newValues)
    };

    const onSelectArea = (i,type) => {
        const data = {
            filled:true,
            id:i.id,
            name:i.name,
            countryCode:i.country_code,
            countryName:i.country_name,
            adm1name:i.administrative_division_level_1_name,
            adm1type:i.administrative_division_level_1_type,
            adm2name:i.administrative_division_level_2_name,
            adm2type:i.administrative_division_level_2_type,
            adm3name:i.administrative_division_level_3_name,
            adm3type:i.administrative_division_level_3_type,
            postalCode:i.postal_code
        }
        if (type === 'origin') {
            setOSelectedArea(data)
        } else {
            setDSelectedArea(data)
        }
        
    };

    const onSubmit = async () => {
        setSubmitLoading(true)
        try {
            trackEvent("Check Shipping Rates",{
                action: "track",
                category: "Tools",
                label: 'Check shipping rates from website',
                event: "Click"
            });

            const res = await axios.post(`${API}/v1/rates/couriers?channel=biteship_landing_page`, {
                origin_area_id:originId,
                destination_area_id:destinationId,
                couriers:'jne,sicepat,anteraja,wahana,rpx,idexpress,jdl,lion,tiki,jnt,ninja,sap,pos',
                items:[item]
            },{
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            });
            


            if (res.data.success) {
                const pricing = res.data.pricing;
                const cSa = pricing.filter(i => i.service_type === 'sameDay' ) || [];
                const cPa = pricing.filter(i => i.shipping_type === 'parcel' ) || [];
                const cIn = pricing.filter(i => i.service_type === 'instant' ) || [];
                const cOv = pricing.filter(i => i.service_type === 'overnight' ) || [];
                const cSt = pricing.filter(i => i.service_type === 'standard' ) || [];
                const cFr = pricing.filter(i => i.shipping_type === 'freight') || [];
                const sht = cPa.length > 0 ? 'parcel' : 'freight';
                const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';
                setCouriers({
                    ...couriers,
                    courierOption:pricing,
                    courierOptionFiltered:pricing,
                    courierSameDay:cSa.length,
                    courierParcel:cPa.length,
                    courierInstant:cIn.length,
                    courierOvernight:cOv.length,
                    courierStandard:cSt.length,
                    courierFreight: cFr.length,
                    shippingType: sht,
                    serviceType: set
                });
            } else {
                alert(res.data.error)
            }
        } catch (e) {
            console.log (e)
        }
        setSubmitLoading(false)
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Cek Ongkos Kirim</title>
                <meta name="description" content="Biteship adalah platform untuk melakukan pemesanan dari berbagai macam kurir dibangun untuk para pemilik bisnis.
                Terdapat lebih dari 20 Kurir Indonesia yang bergabung menjadi partner pengiriman. Kami membantu optimasi pengiriman Anda secara end-to-end." />
                <link rel="canonical" href="https://biteship.com" />
            </Helmet>
            <LandingPageNav/>
            
            <section className="slice">
                <div className="pt-5 container">
                        <h1 className="text-black lh-150"><strong>Cek Ongkos Kirim (Ongkir) Semua Ekspedisi</strong></h1>
                        <h2 className="text-violet-500 lh-150"><strong>Cek tarif pengiriman atau cek ongkos kirim layanan pengiriman Anda.</strong></h2>
                        <p className="lead lh-180">
                            Gunakan fasilitas cek ongkir Biteship secara gratis untuk keperluan Anda. Mulai dari pengiriman instant, same day, next day dan reguler dapat di cek melalui halaman cek ongkos kirim disini.
                        </p>
                     
                </div>
            </section>

            <div className='bg-violet-900 py-5 mb-5'>
                <div className="py-5">
                    <div className="container p-4 shadow card bg-white " style={{borderRadius:16}}>
                        <form>
                            <div className="form-row">
                                <div className="col-md-4 col-12" >
                                    <label className='lead lh-150'><strong>Wilayah Asal</strong></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nama kota / kecamatan / kodepos"
                                        onChange={onChange('origin')}
                                        value={originAreaInput}
                                    />
                                    {
                                        areaLoadingSingle && inputType === 'origin' ?
                                            <div className="card mt-1" style={{position:'absolute'}}>
                                                <text className="text-muted" >Mencari Lokasi...</text>
                                            </div> : originId === '' && originAreaInput.length > 0 && inputType === 'origin' && oAreas.length > 0?
                                            <div className="card mt-1" style={{position:'absolute',height:320,overflow:'scroll'}}>
                                                {
                                                    oAreas.map(i => (
                                                        <div onClick={() => onSelectDistrict(i,'origin')} className="docs-area pointer p-2 border-bottom">
                                                            <a>{i.name}</a>
                                                        </div>
                                                    ))
                                                }
                                            </div> : null
                                    }
                                </div>
                                <div className="col-md-4 col-12">
                                    <label className='lead lh-150'><strong>Wilayah Tujuan</strong></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nama kota / kecamatan / kodepos"
                                        onChange={onChange('destination')}
                                        value={destinationAreaInput}
                                    />
                                    {
                                        areaLoadingSingle && inputType === 'destination' ?
                                            <div className="card mt-1" style={{position:'absolute'}}>
                                                <text className="text-muted">Mencari Lokasi...</text>
                                            </div> : destinationId === '' && destinationAreaInput.length > 0 && inputType === 'destination' && dAreas.length > 0 ?
                                            <div className="card mt-1" style={{position:'absolute',height:320,overflow:'scroll'}}>
                                                {
                                                    dAreas.map(i => (
                                                        <div onClick={() => onSelectDistrict(i,'destination')} className="docs-area pointer p-2 border-bottom">
                                                            <a>{i.name}</a>
                                                        </div>
                                                    ))
                                                }
                                            </div> : null
                                    }
                                </div>
                                
                                <div className="col-md-2 col-12">
                                    <label className='lead lh-150'><strong>Berat Barang (gram)</strong></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Satuan Gram"
                                        onChange={onItemChange('weight')}
                                        value={item.weight}
                                    />
                                </div>

                                <div className="col-md-2 col-12">
                                    <label className='text-white'>Cek Ongkir</label>
                                    <Button
                                        onClick={() => onSubmit()}
                                        className="btn btn-primary col-12"
                                        loading={submitLoading}
                                    >
                                        Cek Ongkir
                                    </Button>
                                </div>

                            </div>
                        </form>
                        
                    
                        

                        {
                            couriers.courierOption.length === 0 ? null :
                            <div>
                                <hr/>
                                <h4>Filter</h4>
                                <div className='my-4 row'>
                                    {
                                    (couriers.courierParcel > 0 && couriers.courierFreight === 0 )||
                                    (couriers.courierParcel === 0 && couriers.courierFreight > 0 ) ?
                                        null :
                                        <Nav
                                            fill
                                            className="ml-2"
                                            variant="pills"
                                            defaultActiveKey="/home"
                                            onSelect={shippingTypeChange}>
                                            {
                                            couriers.courierParcel > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="parcel" active={couriers.shippingType === 'parcel'}>
                                                    Paket
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                            {
                                            couriers.courierFreight > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="freight" active={couriers.shippingType === 'freight'}>
                                                    Kargo
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                        </Nav>
                                    }

                                    {
                                    couriers.shippingType === 'parcel' && courierParcelNav() ?
                                        <Nav
                                            fill
                                            className="ml-2"
                                            variant="pills"
                                            defaultActiveKey="/home"
                                            onSelect={serviceTypeChange}>
                                            {
                                            couriers.courierInstant > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="instant" active={couriers.serviceType === 'instant'}>
                                                    Instant
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                            {
                                            couriers.courierSameDay > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="sameDay" active={couriers.serviceType === 'sameDay'}>
                                                    Sehari Sampai 
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                            {
                                            couriers.courierOvernight > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="overnight" active={couriers.serviceType === 'overnight'}>
                                                    Besok Sampai
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                            {
                                            couriers.courierStandard > 0 ?
                                                <Nav.Item>
                                                    <Nav.Link className="py-2" eventKey="standard" active={couriers.serviceType === 'standard'}>
                                                    Standard
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : null
                                            }
                                        </Nav> : ""
                                    }
                                </div>
                                
                                {
                                    couriers.courierOptionFiltered.map((i,idx) => {
                                        const imageName = `${i.courier_code}.png`
                                        return (
                                            <div key={idx} className="px-3 card mt-2 shadow">
                                                <div className={`col-12 py-1 rounded mb-2 row d-flex justify-content-between  align-items-center`}>
                                                    <div className="col-2 text-center">
                                                        <img alt="Biteship Courier" style={{height:42,width:`auto`}} src={require(`../../../public/images/landing/${imageName}`)}/>                                              
                                                    </div>
                                                    <div className='col-2'>
                                                        <p>Nama Kurir</p>
                                                        <p className="lead lh-150">{i.courier_name}</p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p>Jenis Layanan</p>
                                                        <p className="lead lh-150">{i.courier_service_name}</p>
                                                    </div>
                                                    <div className='col-2'>
                                                        <p>Durasi Pengiriman</p>
                                                        <p className="m-0 lead">
                                                            {i.shipment_duration_range} {i.shipment_duration_unit.includes('day') ? 'Hari' : 'Jam'}
                                                        </p>
                                                    </div>
                                                    <div className="text-right col-2">
                                                        <p>Harga Layanan</p>
                                                        <p className={`lead text-success text-right`}>
                                                            <strong>Rp. {numeral(i.price).format("0,0")}</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }   
                                <div className='text-center mt-4'>
                                    <a href="https://dashboard.biteship.com?utm_source=biteship-shipping-rates&utm_medium=website&utm_campaign=general&utm_id=general">
                                        <button className="btn btn-primary" >
                                            Daftar untuk melihat list lengkap kurir
                                        </button>
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            
            <div className='text-center container'>
                <h2 className='text-lg text-muted'>
                    Cek Ongkir Ekspedisi
                </h2>
                <p className='text-light'>
                    Cek mulai dari SiCepat, J&T, Tiki, JNE, Shopee Express, AnterAja, Wahana dan lainnya. Biteship merupakan layanan pengiriman yang menyediakan aplikasi cek ongkir atau cek tarif pengiriman untuk bisnis Anda. Anda bisa cek ongkir JNE, cek ongkir TIKI, cek ongkir J&T, cek ongkir AnterAja dan cek ongkir kurir pengiriman lainnya. Cek tarif bisa dilakukan untuk berbagai kota tergantung pengiriman asal dan tujuan Anda. Semua kurir lengkap terdapat di Biteship sesuai kebutuhan bisnis Anda. 
                </p>
            </div>
        

            <div>
                <div className='text-center container'>
                    <h2 className='text-lg text-muted'>
                        API Cek Ongkir atau API Cek Tarif Pengiriman
                    </h2>
                    <p className='text-light'>
                        Biteship menyediakan API Cek Ongkir atau API Cek Ongkos Kirim atau API Cek Tarif ekspedisi untuk kebutuhan bisnis Anda. Anda bisa integrasikan website Anda untuk terhubung dengan API cek ongkir ekspedisi milik Bitehsip. Semua list layanan API JNE atau JNE API, API Gosend atau Gosend API, API AnterAja atau AnterAja API, API Deliveree atau Deliveree API, API Borzo, API Grab atau Grab API, API SiCepat atau SiCepat API, J&T API atau API J&T semua tersedia di Biteship.  
                    </p>
                </div>

                <div className='text-center container'>
                    <h2 className='text-lg text-muted'>
                        List Lengkap Cek Ongkir
                    </h2>
                    <p className='text-light'>
                        Biteship memiliki list layanan lengkap untuk Anda bisa cek ongkir atau cek tarif pengiriman atau cek ongkos kirim ekspedisi. 
                        Anda bisa cek ongkos kirim JNE atau cek ongkir JNE dan cek tarif JNE. Selain itu
                        Anda juga bisa cek ongkos kirim J&T atau cek ongkir J&T dan cek tarif J&T. Selain itu
                        Anda juga bisa cek ongkos kirim TIKI atau cek ongkir TIKI dan cek tarif TIKI. Selain itu
                        Anda juga bisa cek ongkos kirim AnterAja atau cek ongkir AnterAja dan cek tarif AnterAja. Selain itu 
                        Anda juga bisa cek ongkos kirim RPX atau cek ongkir RPX dan cek tarif RPX. Selain itu 
                        Anda juga bisa cek ongkos kirim SAP atau cek ongkir SAP dan cek tarif SAP. Selain itu 
                        Anda juga bisa cek ongkos kirim SiCepat atau cek ongkir SiCepat dan cek tarif SiCepat. Selain itu
                        Anda juga bisa cek ongkos kirim POS Indonesia atau cek ongkir POS Indonesia dan cek tarif POS Indonesia. Selain itu
                        Anda juga bisa cek ongkos kirim Paxel atau cek ongkir Paxel dan cek tarif Paxel. Selain itu
                        Anda juga bisa cek ongkos kirim Gojek atau cek ongkir Gojek dan cek tarif Gojek. Selain itu
                        Anda juga bisa cek ongkos kirim GRAB atau cek ongkir GRAB dan cek tarif GRAB. Semua Tersedia via Biteship.
                    </p>
                </div>
            </div>
            
            
            <div style={{height:320}}/>
            

            <Section/>
            <FooterLandingPage/>
        </>
        
    )
};

export default ShippingRates;
